import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

export const WhyItMatters = () => {
  const { t } = useLang();
  return (
    <section id="why" className="relative py-24 sm:py-32 bg-[var(--page)]">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} variants={reveal}>
            <span className="text-xs uppercase tracking-[0.25em] text-terra font-semibold">{t.why.overline}</span>
            <h2 className="mt-5 font-display text-[var(--ink)] font-semibold tracking-tight leading-[1.05]
                           text-3xl sm:text-4xl lg:text-5xl">
              {t.why.title}
            </h2>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-[var(--muted-ink)] max-w-md">
              {t.why.body}
            </p>
          </motion.div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-x-10 gap-y-10">
          {t.why.points.map((p, i) => (
            <motion.div
              key={i}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              variants={reveal}
              className="border-t border-[var(--hairline)] pt-5"
              data-testid={`trust-point-${i}`}
            >
              <h3 className="font-display text-xl sm:text-2xl text-[var(--ink)] leading-snug">{p.title}</h3>
              <p className="mt-3 text-sm sm:text-base leading-relaxed text-[var(--muted-ink)]">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
